export class SingleCard {
  constructor(
    img,
    title,
    description,
    seeProject_URL,
    gitHub_F_END,
    gitHub_B_END,
    btnSwitch,
  ) {
    this.img = img;
    this.title = title;
    this.description = description;
    this.seeProject_URL = seeProject_URL;
    this.gitHub_F_END = gitHub_F_END;
    this.gitHub_B_END = gitHub_B_END;
    this.btnSwitch = btnSwitch;
  }
}
